module.exports = __webpack_public_path__ + "img/1499654846.0dfc1fee.jpg";